export default "__VITE_ASSET__CMHXCNcb__"